import Validator, { ValidatorModel } from "./validator";
import { ErrorMessages } from "./errorMessage";

export const distancePolicyValidators: ValidatorModel = {
    distancePolicy: [
        {name: "distanceIsNotEmpty", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required}
    ]
};
